// Tablero de los agentes: primero lo que necesita a una persona (escrituras por aprobar), después lo que está
// trabajando y lo último que terminó. Cada trabajo abre su línea de tiempo.
import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Cargando, PageHead, Tabla, Vacio } from '@glubi/ds';
import { api } from '../lib/api';
import { desde, momento, usd } from '../lib/formato';
import { Estado } from '../componentes/Comunes';
import { Decidir, DetalleEjecucion } from '../componentes/Trabajo';

export function Tablero() {
  const q = useQuery({ queryKey: ['tablero'], queryFn: () => api<{ porAprobar: any[]; enCurso: any[]; recientes: any[] }>('/api/tablero'), refetchInterval: 5000 });
  const [abierto, setAbierto] = useState<string | null>(null);

  if (q.isLoading || !q.data) return <Cargando />;
  const { porAprobar, enCurso, recientes } = q.data;
  const columnas = [
    { key: 'nombre', label: 'Quién', render: (e: any) => <div><b style={{ fontWeight: 500 }}>{e.nombre}</b><div className="muted" style={{ fontSize: 12 }}>{e.tipo === 'rutina' ? 'Rutina' : 'Agente'} · {e.disparador === 'horario' ? 'por horario' : 'a mano'}</div></div> },
    { key: 'encargo', label: 'Qué', render: (e: any) => <div style={{ fontSize: 13, maxWidth: 380 }}>{(e.resultado ?? e.error ?? e.encargo ?? '').slice(0, 160)}</div> },
    { key: 'costo', label: 'Costo', numeric: true, render: (e: any) => usd(e.costo) },
    { key: 'creado_en', label: 'Cuándo', render: (e: any) => desde(e.terminada_en ?? e.creado_en) },
    { key: 'estado', label: 'Estado', render: (e: any) => <Estado estado={e.estado} /> },
  ];

  return (
    <div className="page">
      <PageHead title="Tablero" subtitle="El trabajo de los agentes y las rutinas del negocio. Ninguna escritura se hace sin que alguien la apruebe, salvo las que se concedieron a propósito." />

      <div className="h-card" style={{ margin: '4px 0 10px' }}>Necesita tu atención</div>
      {!porAprobar.length ? (
        <div className="ok-caja" style={{ marginBottom: 22 }}>Nada por aprobar.</div>
      ) : (
        <div className="grid-2" style={{ marginBottom: 22 }}>
          {porAprobar.map((p) => (
            <div key={p.id} className="card" style={{ padding: 16, borderColor: 'var(--amber)' }}>
              <div style={{ fontSize: 14, marginBottom: 6 }}><b style={{ fontWeight: 500 }}>{p.nombre}</b> quiere escribir con <code>{p.herramienta}</code></div>
              <pre className="codigo" style={{ marginBottom: 8 }}>{JSON.stringify(p.argumentos, null, 2)}</pre>
              <div className="muted" style={{ fontSize: 12, marginBottom: 10 }}>{momento(p.creado_en)} · <button className="enlace" onClick={() => setAbierto(p.raiz_id)}>ver el trabajo</button></div>
              <Decidir aprobacion={p} compacto />
            </div>
          ))}
        </div>
      )}

      <div className="h-card" style={{ margin: '4px 0 10px' }}>Trabajando</div>
      {!enCurso.filter((e) => e.estado !== 'esperando_aprobacion').length
        ? <div className="muted" style={{ fontSize: 14, marginBottom: 22 }}>Ningún agente está trabajando ahora.</div>
        : <div style={{ marginBottom: 22 }}><Tabla rowKey="id" rows={enCurso.filter((e) => e.estado !== 'esperando_aprobacion')} columns={columnas} onRowClick={(e: any) => setAbierto(e.id)} /></div>}

      <div className="h-card" style={{ margin: '4px 0 10px' }}>Terminó hace poco</div>
      {!recientes.length ? (
        <Vacio titulo="Todavía no hay trabajo">Crear un agente en <Link to="/agentes">Agentes</Link> y encargarle algo, o armar una <Link to="/rutinas">rutina</Link>.</Vacio>
      ) : <Tabla rowKey="id" rows={recientes} columns={columnas} onRowClick={(e: any) => setAbierto(e.id)} />}

      {abierto && <DetalleEjecucion id={abierto} onClose={() => setAbierto(null)} />}
    </div>
  );
}
